export const getBidEditorStyle = () => ({
  form: {
    fontSize: '14px !important',
    '& .error': {
      color: '#a80000',
    },
    '& .search-bid-editor': {
      '& .bid-input': {
        '& input': {
          width: 'auto',
          display: 'inline-block',
          marginRight: '10px',
          verticalAlign: 'top',
        },
        '& div[role="alert"]': {
          marginTop: 5,
        },
        '& .input-addon': {
          position: 'absolute',
          left: 195,
          whiteSpace: 'nowrap',
          margin: '6px 12px',
        },
      },
      '& .bidWarning': {
        marginTop: 6,
      },
    },
  },
});
